/* maceratie.js — meet de headerhoogte zodat de hero er strak onder schuift */
(function () {
  function setHeaderHeight() {
    var header = document.querySelector('.section-header');
    if (!header) return;
    document.documentElement.style.setProperty('--mac-header-h', header.offsetHeight + 'px');
  }
  window.addEventListener('resize', setHeaderHeight);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setHeaderHeight);
  } else {
    setHeaderHeight();
  }
})();
